import React from 'react';
import './index.css';

const SubscriptionPolicyPage = () => {
    return (
        <div className="policy-page-container">
            <h1>💳 SUBSCRIPTION POLICY — NOTTSIFY</h1>

            <h2>Subscriptions include:</h2>
            <ul>
                <li>Monthly Plan</li>
                <li>Yearly Plan</li>
            </ul>

            <h2>Auto Renewal</h2>
            <p>Subscriptions auto-renew unless cancelled before billing date.</p>

            <h2>Cancellation</h2>
            <ul>
                <li>Users can cancel anytime.</li>
                <li>Access continues till billing cycle ends.</li>
            </ul>
        </div>
    );
};

export default SubscriptionPolicyPage;
